import { render, staticRenderFns } from "./Sidebar.vue?vue&type=template&id=21e33c5e"
import script from "./Sidebar.vue?vue&type=script&lang=js"
export * from "./Sidebar.vue?vue&type=script&lang=js"
import style0 from "./Sidebar.vue?vue&type=style&index=0&id=21e33c5e&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/julie/Works/openmetacity/Meta_Land-Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('21e33c5e')) {
      api.createRecord('21e33c5e', component.options)
    } else {
      api.reload('21e33c5e', component.options)
    }
    module.hot.accept("./Sidebar.vue?vue&type=template&id=21e33c5e", function () {
      api.rerender('21e33c5e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layouts/partials/Sidebar.vue"
export default component.exports